/**
 * returns an array of strings by filtering out all falsy values.
 * @param firstParameter The primary QueryKey enum
 * @param restParameters any subsequent parameters that need to be added to the query key
 */
export const createQueryKey = (baseKey: string, ...params: any[]): string[] => {
  return [baseKey, ...params.filter(Boolean)].map(String);
};
